<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import PostalCodeHeatmap from "../components/demographics/PostalCodeHeatmap.vue";
import { getLocations } from "@/api/locations";
import { getIndex, setLocation } from "@/utils";
import swal from "sweetalert";
import Multiselect from "vue-multiselect";
export default {
  components: { PostalCodeHeatmap, Multiselect },
  name: "heatmap",
  data() {
    return {
      category: { name: "Overall Customers", value: "sales" },
      categoryOptions: [
        { name: "Overall Customers", value: "sales" },
        { name: "New Customers", value: "new" },
        { name: "Competitor Customers", value: "competition" }
      ],
      locations: [],
      selectedLocation: null,
      selected_location: null,
      filteredLocations: [],
      swap: false,
      loading: true
    };
  },
  async beforeMount() {
  },
  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Customer Journey" }]);
    this.$store.commit("setLocationVisibile", false);
    const response = await getLocations();
    let elems = document.getElementsByClassName("multiselect__content");
    if (elems[0]) {
      elems[0].style.paddingLeft = "0px";
    }
    if (!response) {
      swal(
        "",
        "Something went wrong in fetching locations. Please try again later"
      );
    }
    if (response) {
      let locations = response;
      this.locations = locations.filter(
        location => location.latitude && location.longtitude
      );
      // this.locations.push({ id: null, name: "Please select", full_address: "-"})
      let index = getIndex(response);
      let selected = response[index];
      // this.selected_location = selected;
      setLocation(selected);
    }
    // this.$store.dispatch("getLocations");
    setTimeout(() => {
      this.onSearch();
    }, 1000);
  },
  computed: {
    ...mapGetters(["layoutConfig"]),

    config() {
      return this.layoutConfig();
    },
    getLocations() {
      return this.$store.getters["getLocations"].filter(
        location => location.latitude && location.longtitude
      );
    },
    locationsOptions() {
      return [
        { value: null, text: "Please select" },
        ...this.locations.map(list => {
          return {
            value: list.id,
            text: `${list.name}`,
            address: `${list.full_address}`
          };
        })
      ];
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
          document.title = to.meta.title || 'Aben';
      }
    },
    getLocations(newVal) {
      this.locations = newVal.filter(
        location => location.latitude && location.longtitude
      );
    }
  },
  methods: {
    onSearch() {
      this.selectedLocation = this.selected_location;
      console.log(this.selected_location);
      console.log(this.selectedLocation);
      this.handleLocationChange();
    },
    customLabel({ name, street }) {
      return `${name} – ${street}`;
    },
    viewDetails(value) {
      let msg = "";
      if (value == "sales") {
        msg = "The below heatmap displays where your customers live. ";
      }
      if (value == "new") {
        msg = "The below heatmap displays where your new customers live. ";
      }
      if (value == "competition") {
        msg =
          "The below heatmap displays where your competitors' customers live. ";
      }
      return `${msg} Hover over a location to display zip code and value`;
    },
    handleLocationChange() {
      if (this.selectedLocation) {
        this.filteredLocations = this.locations
          .filter(location => location.latitude && location.longtitude)
          .filter(location => location.id === this.selectedLocation.id);
      }

      this.swap = false;
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
        this.swap = true;
      }, 1000);
    }
  }
};
</script>
<style src="@/assets/css/vue-multiselect.min.css"></style>
<style scoped>
.outer-container {
  margin: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.map {
  width: 100%;
}
.subheader {
  background: #e9eaf3 !important;
}
.aside-fixed.subheader-fixed .subheader {
  left: 200px;
}
.aside-minimize.subheader-fixed .subheader {
  left: 70px;
}
.content-box {
  margin-top: 40px;
}
@media only screen and (max-width: 768px) {
  .content-box {
    margin-top: 0px;
  }
}
.location_address {
  font-size: 11px;
  color: rgba (0, 0, 0, 0.54);
}
</style>

<template>
  <v-app class="bg-transparent">
    <v-main>
      <!-- Subheader start -->
      <div
        class="subheader py-2 py-lg-4 d-flex align-items-center justify-content-center"
      >
        <div class="mr-2" style="width: 350px;">
          <multiselect
            v-model="category"
            placeholder="Select Category"
            label="name"
            track-by="name"
            :options="categoryOptions"
            :show-labels="false"
            :taggable="true"
          >
          </multiselect>
        </div>
        <div class="mr-2" style="width: 350px;">
          <multiselect
            v-model="selected_location"
            placeholder="Select Locations"
            label="name"
            track-by="name"
            :options="locations"
            :custom-label="customLabel"
            :show-labels="false"
            :taggable="true"
          >
            <template slot="singleLabel" slot-scope="props">
              <div style="font-size: 14px; line-height: 13px;">
                <strong>{{ props.option.name }}</strong> <br />
                <span class="location_address">
                  {{ props.option.full_address }}
                </span>
              </div>
            </template>
            <template slot="option" slot-scope="props">
              <div style="font-family: tahoma;">
                <div style="font-size:14px">{{ props.option.name }}</div>
                <div style="font-size:11px;">
                  {{ props.option.full_address }}
                </div>
              </div>
            </template>
          </multiselect>
        </div>
        <div class="ml-2">
          <v-btn
            depressed
            color="primary"
            id="myBtn"
            @click="onSearch"
            :loading="loading"
            :disabled="loading"
          >
            <v-icon> mdi-magnify </v-icon>
          </v-btn>
        </div>
      </div>
      <!-- Subheader end -->
      <div class="content-box">
        <v-alert outlined type="info" text class="mt-15">
          Customer Journey allows you to visualize where your existing customers
          are coming from, your new customers are coming from, and your
          competitors' customers are coming from, by location.
        </v-alert>
        <v-card class="p-5" v-if="selectedLocation">
          <v-alert>
            {{ viewDetails(category.value) }}
          </v-alert>
          <div class="map">
            <postal-code-heatmap
              :category="category && category.value ? category.value : null"
              :locations="filteredLocations"
              v-if="swap"
            ></postal-code-heatmap>
          </div>
        </v-card>
      </div>
    </v-main>
  </v-app>
</template>
